import React from 'react'
import Angle from '../icons/Angle'
import Checkbox from './Checkbox'
import styles from './DropdownSelector.module.css'
import Tag from './Tag'
import { WarningIcon } from '../icons/Warning'

interface DropdownSelectorProps {
  placeholder: string
  onChange: (checkedItems: string[]) => void
  error?: boolean
  errorText?: string
  dropdownItems: string[]
  checkedItems: string[]
}

function DropdownSelector({ placeholder, onChange, error, errorText, dropdownItems, checkedItems }: DropdownSelectorProps) {
  const [dropdownMenuActive, setDropdownMenuActive] = React.useState<boolean>(false)

  const handleCheckboxChange = (item: string) => {
    const newCheckedItems = checkedItems.includes(item)
      ? checkedItems.filter(i => i !== item)
      : [...checkedItems, item]
    onChange(newCheckedItems)
  }

  return (
    <>
      <div className={styles.container} onClick={() => setDropdownMenuActive(!dropdownMenuActive)}>
        <div className={error ? styles.inputError : styles.input}
        >
          {checkedItems && (
            <div className={styles.tagsContainer}>
              {checkedItems.map((item, index) => (
                <Tag
                  key={index}
                  name={item}
                  onRemoveTag={handleCheckboxChange}
                />
              ))}
              <span className={styles.placeholder}>{placeholder}</span>
            </div>
          )}
        </div>
        <button className={styles.dropdownButton} onClick={() => setDropdownMenuActive(!dropdownMenuActive)}>
          <Angle className={dropdownMenuActive ? styles.toggleArrowIcon : styles.arrowIcon} color="#000" direction="down" />
        </button>
      </div>
      {dropdownMenuActive && (
        <div>
          <ul className={styles.dropdownList}>
            {dropdownItems && dropdownItems.map((item, index) => (
              <li key={index} className={styles.dropdownItem}>
                <Checkbox
                  id={item}
                  label={item}
                  checked={checkedItems.includes(item)}
                  onChange={(e) => handleCheckboxChange(e.target.id)}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
      {error && <p className={styles.errorText}><span className={styles.errorIcon}><WarningIcon color={'var(--redMid)'} /></span>{errorText}</p>}
    </>
  )
}

export default DropdownSelector